'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ColumnMenuButton = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ArrowIcon = require('../../DropdownMenus/ArrowIcon/ArrowIcon');

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
    'button': 'ColumnMenuButton__button___X3CoH'
};
var ColumnMenuButton = exports.ColumnMenuButton = function ColumnMenuButton(_ref) {
    var column = _ref.column,
        suppressMovable = _ref.suppressMovable,
        showColumnMenu = _ref.showColumnMenu;

    var isVisible = !(0, _lodash2.default)(column, 'colDef.pinned') && !suppressMovable;
    var ref = (0, _react.useRef)();
    var onClick = (0, _react.useCallback)(function () {
        showColumnMenu(ref.current);
    }, [showColumnMenu]);

    if (!isVisible) {
        return null;
    }

    return _react2.default.createElement(
        'button',
        { ref: ref, onClick: onClick, className: styles['button'] },
        _react2.default.createElement(_ArrowIcon2.default, null)
    );
};

ColumnMenuButton.propTypes = {
    api: _propTypes2.default.object,
    column: _propTypes2.default.object,
    suppressMovable: _propTypes2.default.bool,
    showColumnMenu: _propTypes2.default.func
};